// extracted by mini-css-extract-plugin
export default {"logout_wrapper":"LogoutButton_logout_wrapper__EriZY"};